import { keymap } from "prosemirror-keymap";
import { goToNextCell, tableEditing, columnResizing } from "prosemirror-tables";
import { Extension } from "../../core/extension";
import { tableCommandSpec } from "./commands";
import { tableMenu } from "./menu";
import { tableNodesSpec } from "./schema";
export class TableExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(tableNodesSpec());
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([
            tableEditing(),
            columnResizing({}),
            tableMenu(portalContainer),
            keymap({
                Tab: goToNextCell(1),
                "Shift-Tab": goToNextCell(-1),
            }),
        ]);
    }
    addSlashCommands(commands) {
        return [...commands, tableCommandSpec];
    }
}
